/**
 * Build identity — baked in at build time by vite.config.ts (`define`).
 * Shown in the 🐞 debug panel so whoever's testing on a phone can confirm
 * they're actually on the build that was just shipped (Cloudflare Pages
 * caches aggressively; "hard refresh and it's still wrong" usually means
 * the deploy hasn't landed yet, not that the fix is wrong).
 */

/** e.g. "0.1.0+a1b2c3d" or "0.1.0+a1b2c3d-dirty" if built from a dirty tree. */
export const APP_VERSION = `${__APP_VERSION__}+${__GIT_HASH__}${__GIT_DIRTY__ ? '-dirty' : ''}`;

/** Build timestamp, trimmed to minute precision: "2026-07-11 12:34 UTC". */
export const BUILD_TIME = (() => {
  const iso = __BUILD_TIME__; // e.g. 2026-07-11T12:34:56.789Z
  const m = /^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})/.exec(iso);
  return m ? `${m[1]} ${m[2]} UTC` : iso;
})();

/** One-line summary for the debug panel. */
export function getVersionLine(): string {
  return `version: ${APP_VERSION} · built ${BUILD_TIME}`;
}
